class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    this.slides = [...this.querySelectorAll('[data-hero-slide]')];
    this.counter = this.querySelector('[data-hero-counter]');
    this.cta = this.querySelector('[data-hero-cta]');
    this.heading = this.querySelector('[data-hero-heading]');
    this.body = this.querySelector('[data-hero-body]');
    this.playbackButton = this.querySelector('[data-hero-autoplay]');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.editor = Boolean(window.Shopify?.designMode);
    this.paused ??= false;
    this.hovered = this.matches(':hover');
    this.querySelector('[data-hero-controls]').hidden = this.slides.length < 2;
    if (!this.slides.length) return;
    this.show(0);
    this.addEventListener('click', event => {
      if (event.target.closest('[data-hero-autoplay]')) {
        this.paused = !this.paused;
        this.updatePlayback();
        return;
      }
      const button = event.target.closest('[data-hero-change]');
      if (button) {
        this.pause();
        this.show(this.index + Number(button.dataset.heroChange));
      }
    }, { signal: this.events.signal });
    this.addEventListener('keydown', event => {
      if (this.slides.length < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.pause();
      this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
    }, { signal: this.events.signal });
    document.addEventListener('shopify:block:select', event => {
      const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
      if (index >= 0) {
        this.pause();
        this.show(index);
      }
    }, { signal: this.events.signal });
    this.addEventListener('mouseenter', () => { this.hovered = true; this.updatePlayback(); }, { signal: this.events.signal });
    this.addEventListener('mouseleave', () => { this.hovered = false; this.updatePlayback(); }, { signal: this.events.signal });
    this.addEventListener('focusin', event => {
      if (!event.target.closest('[data-hero-autoplay]')) this.pause();
    }, { signal: this.events.signal });
    document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal: this.events.signal });
    this.motion.addEventListener('change', () => this.updatePlayback(), { signal: this.events.signal });
    this.updatePlayback();
  }

  disconnectedCallback() {
    this.events?.abort();
    clearInterval(this.timer);
  }

  pause() {
    this.paused = true;
    this.updatePlayback();
  }

  updatePlayback() {
    clearInterval(this.timer);
    const running = this.slides.length > 1 && !this.paused && !this.motion.matches && !this.editor && !document.hidden && !this.hovered;
    this.playbackButton.hidden = this.motion.matches || this.editor;
    this.playbackButton.setAttribute('aria-label', this.paused ? this.playbackButton.dataset.playLabel : this.playbackButton.dataset.pauseLabel);
    this.playbackButton.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
    this.counter.setAttribute('aria-live', running ? 'off' : 'polite');
    if (running) this.timer = setInterval(() => this.show(this.index + 1), 6000);
  }

  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    const slide = this.slides[this.index];
    if (this.heading) this.heading.textContent = slide.dataset.heading;
    if (this.body) this.body.textContent = slide.dataset.body;
    this.cta.href = slide.dataset.ctaUrl;
    this.cta.querySelector('[data-hero-cta-label]').textContent = slide.dataset.ctaLabel;
    this.counter.textContent = this.dataset.statusTemplate.replace('__current__', String(this.index + 1));
  }
}

if (!customElements.get('hnl-hero-slider')) customElements.define('hnl-hero-slider', HeroSlider);
